export function waitForEvent(element, type) {
  return new Promise(resolve => {
    element.addEventListener(type, resolve, {once: true})
  })
}

export function domTableToText(table, max_width = 50) {
  if (!table) return 'No table found.'

  // extracting rows and cells
  const rawRows = Array.from(table.rows).map(row =>
    Array.from(row.cells).map(cell => cell.textContent.trim())
  )

  // limit the width of each cell and split it into rows.
  const wrapCell = (text, width) => {
    const words = text.split(' ')
    const lines = []
    let line = ''

    for (const word of words) {
      if ((line + word).length <= width) {
        line += (line ? ' ' : '') + word
      } else {
        if (line) lines.push(line)
        if (word.length > width) {
          // words longer than the maximum width are cut off.
          for (let i = 0; i < word.length; i += width) {
            lines.push(word.slice(i, i + width))
          }
          line = ''
        } else {
          line = word
        }
      }
    }

    if (line) lines.push(line)
    return lines
  }

  // break down all cells and remember their sizes
  const wrappedRows = rawRows.map(row =>
    row.map(cell => wrapCell(cell, max_width))
  )

  const colCount = wrappedRows[0].length
  const colWidths = new Array(colCount).fill(0)

  // determine max width of each column
  for (let col = 0; col < colCount; col++) {
    for (const row of wrappedRows) {
      colWidths[col] = Math.max(
        colWidths[col],
        ...row[col].map(line => line.length)
      )
    }
  }

  const separator = () =>
    '+' + colWidths.map(w => '-'.repeat(w + 2)).join('+') + '+'

  const formatRow = row => {
    const maxLines = Math.max(...row.map(cell => cell.length))
    const lines = []

    for (let i = 0; i < maxLines; i++) {
      const line = '| ' + row.map((cell, col) => {
        const text = cell[i] || ''
        return text.padEnd(colWidths[col], ' ')
      }).join(' | ') + ' |'
      lines.push(line)
    }

    return lines.join('\n')
  }

  const result = []

  // add a header and lines with separators
  wrappedRows.forEach((row, index) => {
    result.push(separator())
    result.push(formatRow(row))
  })
  result.push(separator())

  return result.join('\n')
}

export function domTableToCsv(table_node) {
  const rows = table_node.querySelectorAll('tr')
  const csv = []
  for (let i = 0; i < rows.length; i++) {
    const row = [], cols = rows[i].querySelectorAll('td, th')
    for (var j = 0; j < cols.length; j++) {
      let data = cols[j].innerText.replace(/(\r\n|\n|\r)/gm, '').replace(/(\s\s)/gm, ' ')
      data = data.replace(/"/g, '""')
      row.push('"' + data + '"')
    }
    csv.push(row.join(','))
  }
  const csv_string = csv.join('\n')

  return csv_string
}


export function getTextFromNodes(nodes) {
  if (!nodes) return ''

  return nodes
    .map(n => {
      if (typeof n.children === 'string') {
        return n.children
      }

      if (Array.isArray(n.children)) {
        return getTextFromNodes(n.children)
      }

      return ''
    })
    .join('')
}
